<template>
  <div class="page-wrapper">
    <div class="messages-wrapper">
      <div class="messages-status">
        404
      </div>
      <div class="error-messages">
        <div class="error-message">
          {{ $t("NotFound.Message") }}
        </div>
        <div class="error-desc">
          {{ $t("NotFound.Desc") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class NotFound extends Vue {}
</script>

<style lang="scss" scoped>

.page-wrapper {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  left: 0;
  min-height: 100vh;
  position: absolute;
  top: 0;
  width: 100%;

  &.view {
    padding: 0;
  }

  .messages-wrapper {
    display: flex;

    .messages-status {
      font-size: 4.5rem;
      font-weight: 300;
      line-height: 1;
      margin: 0 1rem;
    }

    .error-messages {
      display: flex;
      flex-flow: column;
      
      .error-desc {
        color: #b0bec5;
      }

      .error-message {
        font-size: 1.5rem;
        font-weight: 500;
        margin-bottom: 0.5rem;
      }
    }
  }
}

</style>
